module.exports = function getResource(label, vars = []) {
    const resources = {
        autoReplenishTitle: `Auto-Replenish (${vars[0]})`,
        changeMethod: 'Change Method',
        deliveryEvery: 'Deliver every:',
        deliveryFrequency: 'Delivery Frequency'
    };

    return resources[label];
};
